import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProjectRow from './components/ProjectRow';
import ProjectModal from './components/ProjectModal';
import Footer from './components/Footer';
import { projects as mockProjects } from './mockData';
import { useApi, useBackendHealth } from './hooks/useApi';
import * as api from './services/api';

function App() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProjects, setFilteredProjects] = useState(mockProjects);
  const [useRealData, setUseRealData] = useState(false);
  
  // Try to fetch status checks from backend
  const { data: statusChecks, loading, error } = useApi(
    api.getStatusChecks,
    []
  );
  
  // Check backend health
  const { isHealthy } = useBackendHealth();

  // Initialize: try to load from backend, fallback to mock data
  useEffect(() => {
    if (isHealthy && statusChecks && statusChecks.length > 0) {
      setUseRealData(true);
      // If backend has data, use it; otherwise use mock data
      setFilteredProjects(statusChecks);
    } else {
      setUseRealData(false);
      setFilteredProjects(mockProjects);
    }
  }, [isHealthy, statusChecks]);

  // Filter projects based on search query
  useEffect(() => {
    if (!searchQuery) {
      setFilteredProjects(useRealData ? (statusChecks || mockProjects) : mockProjects);
      return;
    }

    const query = searchQuery.toLowerCase();
    const projectsToFilter = useRealData ? (statusChecks || mockProjects) : mockProjects;
    
    const filtered = projectsToFilter.filter(project => {
      const company = project.company?.toLowerCase() || '';
      const role = project.role?.toLowerCase() || '';
      const description = project.description?.toLowerCase() || '';
      const technologies = project.technologies || [];
      
      return (
        company.includes(query) ||
        role.includes(query) ||
        description.includes(query) ||
        technologies.some(tech => tech.toLowerCase().includes(query))
      );
    });
    setFilteredProjects(filtered);
  }, [searchQuery, useRealData, statusChecks]);

  const handleProjectClick = (project) => {
    setSelectedProject(project);
  };

  const handleCloseModal = () => {
    setSelectedProject(null);
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  return (
    <div className="bg-[#141414] min-h-screen">
      {/* Backend Status Indicator */}
      {!isHealthy && (
        <div className="bg-yellow-900 bg-opacity-50 px-4 py-2 text-yellow-300 text-sm border-b border-yellow-700">
          ℹ️ Using mock data (Backend unavailable). Using configuration from .env file
        </div>
      )}
      
      <Navbar onSearch={handleSearch} />
      
      <main>
        <Hero onProjectClick={handleProjectClick} />

        {searchQuery && filteredProjects.length === 0 ? (
          <div className="px-12 py-20 text-center">
            <h2 className="text-white text-2xl font-semibold mb-2">
              No results found for "{searchQuery}"
            </h2>
            <p className="text-gray-400">
              Try searching for companies, roles, or technologies like AWS, GCP, Kubernetes
            </p>
          </div>
        ) : (
          <ProjectRow
            title="All Experience"
            projects={filteredProjects}
            onProjectClick={handleProjectClick}
          />
        )}
      </main>

      <Footer />

      <ProjectModal
        project={selectedProject}
        open={!!selectedProject}
        onClose={handleCloseModal}
      />
    </div>
  );
}

export default App;